import { useState } from 'react';
import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { categories, getMoviesByCategory } from '@/mocks/movies';

export default function CategorySection() {
  const [activeTab, setActiveTab] = useState('dongzuo');
  const movies = getMoviesByCategory(activeTab).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型探索您喜欢的影视作品</p>
        </div>

        <div className="flex items-center justify-center flex-wrap gap-2 mb-8">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveTab(cat.slug)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                activeTab === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-600 hover:text-foreground-900 hover:bg-background-200 border border-background-200/60'
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-sm`}></i>
              </span>
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to={`/category/${activeTab}`}
            className="inline-flex items-center gap-1.5 px-6 py-2.5 bg-background-50 hover:bg-background-200 text-foreground-700 font-medium rounded-full border border-background-200/70 transition-all text-sm whitespace-nowrap"
          >
            查看全部{activeTab === 'dianshiju' ? '电视剧' : categories.find((c) => c.slug === activeTab)?.name || ''}
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}